import { useQuery } from '@tanstack/react-query';

import {
  getAllRiskObjectsByPartyIdV2,
  type GetAllRiskObjectsByPartyIdV2Response,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function useRiskObjects(
  partyId: string,
  options?: QueryOptions<GetAllRiskObjectsByPartyIdV2Response>,
) {
  return useQuery({
    queryKey: queryKeys.list(partyId, undefined),
    queryFn: async () => {
      const result = await getAllRiskObjectsByPartyIdV2(
        { path: { party_id: partyId } },
        wgApi,
      );

      return result;
    },
    ...options,
  });
}
